import { DRIVER } from '@/constants/api-types'
import ApiCore from './api-core'

export default class DriverAccount extends ApiCore {
  constructor(store) {
    const path = `${DRIVER}/account`

    super(store, path)
  }

  check(showProgress) {
    return this.request({
      action: 'check',
      method: 'GET',
      showProgress
    })
  }

  available(showProgress) {
    return this.request({
      action: 'available',
      method: 'PATCH',
      showProgress
    })
  }

  unavailable(showProgress) {
    return this.request({
      action: 'unavailable',
      method: 'PATCH',
      showProgress
    })
  }

  loginStatus(showProgress) {
    return this.request({
      action: 'status',
      method: 'GET',
      showProgress
    })
  }

  logout(showProgress) {
    return this.request({
      action: 'logout',
      method: 'DELETE',
      showProgress
    })
  }

  profile(showProgress) {
    return this.request({
      action: 'profile',
      method: 'GET',
      showProgress
    })
  }

  updateProfileInfo(model, showProgress) {
    return this.request({
      action: 'profile',
      method: 'PUT',
      body: model,
      showProgress
    })
  }

  updateProfilePicture(image, showProgress) {
    return this.request({
      action: 'image',
      method: 'PATCH',
      body: { image },
      showProgress
    })
  }

  changePassword(model, showProgress) {
    return this.request({
      action: 'password',
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  changeOtpPassword(model, showProgress) {
    return this.request({
      action: 'otp/password',
      method: 'PATCH',
      body: model,
      showProgress
    })
  }

  sessionReport(filter, showProgress) {
    return this.request({
      action: 'session/report',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  currentSession(showProgress) {
    return this.request({
      action: 'session/current',
      method: 'GET',
      showProgress
    })
  }

  deleteSession(id, showProgress) {
    return this.request({
      action: `session/${id}`,
      method: 'DELETE',
      showProgress
    })
  }

  deleteAllOtherSessions(showProgress) {
    return this.request({
      action: 'session/other',
      method: 'DELETE',
      showProgress
    })
  }

  confirmContract(showProgress) {
    return this.request({
      action: 'confirm/contract',
      method: 'PATCH',
      showProgress
    })
  }
}
